<script lang="ts">
  import Dialog from '../ui/Dialog.svelte';
  import DialogHeader from '../ui/DialogHeader.svelte';
  import { THEMES } from '../themes/registry';
  import scowlLicense from '../../../data/common-words/SCOWL-LICENSE.txt?raw';

  let { open, close }: { open: boolean; close: () => void } = $props();
</script>

<Dialog {open} labelledby="licenses-title" onDismiss={close}>
  {#snippet header()}
    <DialogHeader
      id="licenses-title"
      title="Licenses"
      closeLabel="Close Licenses"
      {close}
      initialFocus="title"
    />
  {/snippet}
  <p>Theme, font and word-list licenses and attribution for Spellie.</p>
  <h3>Theme artwork and audio</h3>
  <p>
    Spellie's original theme illustrations, icons and synthesized music are licensed under the project's MIT
    license.
  </p>
  {#each THEMES as theme (theme.id)}
    <section aria-label={theme.name}>
      <h3>{theme.name}</h3>
      {#if theme.credits}<p>{theme.credits}</p>{/if}
      {#if theme.license}
        <pre>{theme.license}</pre>
      {:else}
        <p>This theme uses system fonts; no font files are bundled with it.</p>
      {/if}
    </section>
  {/each}
  <section aria-label="SCOWL common-word list">
    <h3>SCOWL common-word list</h3>
    <p>
      SCOWLv2 rel-2026.02.25 by Kevin Atkinson and contributors supplies the server-side vocabulary for the
      board difficulty selection. Derived word lists include Australian spelling data.
    </p>
    <pre>{scowlLicense}</pre>
  </section>
</Dialog>

<style>
  pre {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-size: 12px;
    line-height: 1.5;
  }
</style>
